import React, { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { api, formatApiError } from "@/lib/api";
import { useAuth } from "@/contexts/AuthContext";
import BrandLogo from "@/components/brand/BrandLogo";
import CTAButton from "@/components/app/CTAButton";
import { Shield } from "lucide-react";

export default function AdminLogin() {
    const { setAdmin } = useAuth();
    const navigate = useNavigate();
    const loc = useLocation();
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [error, setError] = useState("");
    const [loading, setLoading] = useState(false);

    async function onSubmit(e) {
        e.preventDefault();
        setLoading(true); setError("");
        try {
            const { data } = await api.post("/admin/auth/login", { email, password });
            setAdmin(data);
            const to = loc.state?.from?.pathname || "/admin";
            navigate(to, { replace: true });
        } catch (err) {
            setError(formatApiError(err));
        } finally { setLoading(false); }
    }

    return (
        <div className="flex min-h-screen items-center justify-center bg-md-bg px-4 py-12">
            <div className="w-full max-w-sm">
                <div className="mb-8 flex justify-center"><BrandLogo variant="horizontal" size="md" /></div>
                <div className="rounded-2xl border border-md-border bg-md-surface p-6 sm:p-8">
                    <div className="mb-4 inline-flex items-center gap-2 rounded-full bg-md-surface-2 px-3 py-1.5">
                        <Shield className="h-3.5 w-3.5 text-md-text-2" />
                        <span className="md-overline">Cockpit admin</span>
                    </div>
                    <h1 className="md-h2 text-md-text">Connexion admin</h1>
                    <p className="mt-2 text-sm text-md-text-2">
                        Espace strictement séparé. Aucun profil acheteur ou vendeur ici.
                    </p>
                    <form onSubmit={onSubmit} className="mt-6 space-y-4">
                        <div>
                            <label className="md-overline mb-2 block">Email admin</label>
                            <input
                                type="email" required value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                data-testid="admin-login-email"
                                className="block w-full rounded-lg border border-md-border bg-md-bg px-3 py-2.5 text-sm text-md-text outline-none focus:border-md-primary"
                            />
                        </div>
                        <div>
                            <label className="md-overline mb-2 block">Mot de passe</label>
                            <input
                                type="password" required value={password}
                                onChange={(e) => setPassword(e.target.value)}
                                data-testid="admin-login-password"
                                className="block w-full rounded-lg border border-md-border bg-md-bg px-3 py-2.5 text-sm text-md-text outline-none focus:border-md-primary"
                            />
                        </div>
                        {error && (
                            <div className="rounded-lg border border-md-danger/30 bg-md-danger/10 px-3 py-2 text-xs text-md-danger" data-testid="admin-login-error">
                                {error}
                            </div>
                        )}
                        <CTAButton type="submit" size="block" loading={loading} testId="admin-login-submit">
                            Entrer dans le cockpit
                        </CTAButton>
                    </form>
                </div>
            </div>
        </div>
    );
}
